import Vue from 'vue'
import Router from 'vue-router'
import Login from './views/Login.vue'
import Main from './views/Main.vue'
import Admin  from './views/Admin.vue'
import store from './store';

Vue.use(Router)

const router =  new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'login',
      component: Login
    },
    {
      path: '/main',
      name: 'main',
      component: Main,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/admin',
      name: 'admin',
      component: Admin,
      meta: {
        requiresAuth: true,
        adminAuth: true
      }
    }
  ],
  scrollBehavior(to, from, savedPostion){
    return {
      x: 0,
      y: 0
    }
  }
})

router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    store.dispatch('authorize').then(response => {
      if (store.state.isAuth) {
        next();
        return
      }
      next('/');
    })
  } else {
    next();
  }
});


router.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.adminAuth)) {
    store.dispatch('authorize').then(response => {
      if (store.state.user.isAdmin) {
        next();
        return
      }
      next('/')
    })
  } else {
    next();
  }
})

export default router;